import { MdBlockFlipped, MdGroup } from "react-icons/md";
import { BsMegaphone } from "react-icons/bs";
import { BiSolidVolumeMute } from "react-icons/bi";
import { FaCircleUser } from "react-icons/fa6";
import { ImPhoneHangUp } from "react-icons/im";
import { IoCall } from "react-icons/io5";
import { BiPaste } from "react-icons/bi";
import { BiEdit } from "react-icons/bi";

export const GroupIcon = MdGroup as React.FC;
export const MegaphoneIcon = BsMegaphone as unknown as React.FC;
export const MuteIcon = BiSolidVolumeMute as unknown as React.FC;
export const BlockIcon = MdBlockFlipped as unknown as React.FC;
export const EditIcon = BiEdit as unknown as React.FC;
export const UserAvatarIcon = FaCircleUser as unknown as React.FC;
export const HangupIcon = ImPhoneHangUp as unknown as React.FC;
export const CallAcceptIcon = IoCall as unknown as React.FC;
export const PasteIcon = BiPaste as unknown as React.FC;
